import { render } from "./LocationStockCheck.vue?vue&type=template&id=18a8c237&scoped=true"
import script from "./LocationStockCheck.vue?vue&type=script&lang=js"
export * from "./LocationStockCheck.vue?vue&type=script&lang=js"

import "./LocationStockCheck.vue?vue&type=style&index=0&id=18a8c237&scoped=true&lang=css"

import exportComponent from "/Users/zwl/Desktop/work/DEV/wms-phone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a8c237"]])

export default __exports__